/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import type SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';
import Modal from 'bundles/phoenix/components/Modal';

import _t from 'i18n!nls/account-settings';

import 'css!./__styles__/SettingsModal';

type SECTION_VALUE_TYPES = (typeof SettingsConstants)['Sections'][keyof (typeof SettingsConstants)['Sections']];

type Props = {
  title: string;
  section?: SECTION_VALUE_TYPES;
  onClose?: () => void;
  onButtonClick?: () => void;
  showButton?: boolean;
  allowClose?: boolean;
  buttonText?: string;
};

const styles = {
  heading: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const SettingsModal: React.LegacyFunctionComponentWithChildren<Props> = ({
  title,
  section,
  onClose,
  onButtonClick,
  showButton,
  allowClose,
  buttonText,
  children,
}) => {
  const handleClose = () => {
    if (section) {
      SettingsActionCreators.resetSection(section);
    }

    if (onClose) {
      onClose();
    }
  };

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }

    handleClose();
  };

  const renderButton = () => {
    return (
      <button className="settings-modal-action" onClick={handleButtonClick}>
        {buttonText || _t('OK')}
      </button>
    );
  };

  return (
    <div className="rc-SettingsModal">
      <Modal modalName="SettingsModal" handleClose={handleClose} allowClose={allowClose}>
        <Typography variant="h1" component="h2" css={styles.heading}>
          {title}
        </Typography>
        <div className="settings-modal-content">{children}</div>
        {showButton && renderButton()}
      </Modal>
    </div>
  );
};

export default SettingsModal;
